import { API_BASE_URL } from "../config/apiConfig";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthLayout from "../layouts/AuthLayout";

function ProfessionalLogin() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
    rememberMe: false,
  });

  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  function handleChange(event) {
    const { name, value, type, checked } = event.target;

    setFormData((currentData) => ({
      ...currentData,
      [name]: type === "checkbox" ? checked : value,
    }));
  }

  async function handleSubmit(event) {
    event.preventDefault();

    setError("");
    setIsLoading(true);

    try {
      const response = await fetch(
       `${API_BASE_URL}/auth/login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: formData.email,
            password: formData.password,
          }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Unable to sign in.");
      }

      if (data.user.role !== "professional") {
        throw new Error(
          "This account is not registered as a healthcare professional."
        );
      }

      localStorage.setItem("zethAuthToken", data.token);
      localStorage.setItem("zethUser", JSON.stringify(data.user));

      navigate("/professional/dashboard");
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <AuthLayout
      title="Welcome back."
      description="Sign in to manage assignments, credentials, availability and communication with Zeth Health."
    >
      <div className="auth-card">
        <p className="account-label">Healthcare professionals</p>
        <h2>Professional Login</h2>

        <form className="account-form" onSubmit={handleSubmit}>
          {error && (
            <div className="auth-error" role="alert">
              {error}
            </div>
          )}

          <label htmlFor="professional-email">Email address</label>
          <input
            id="professional-email"
            name="email"
            type="email"
            placeholder="name@example.com"
            value={formData.email}
            onChange={handleChange}
            autoComplete="email"
            required
          />

          <label htmlFor="professional-password">Password</label>
          <input
            id="professional-password"
            name="password"
            type="password"
            placeholder="Enter your password"
            value={formData.password}
            onChange={handleChange}
            autoComplete="current-password"
            required
          />

          <div className="form-options">
            <label className="remember-option">
              <input
                name="rememberMe"
                type="checkbox"
                checked={formData.rememberMe}
                onChange={handleChange}
              />
              Remember me
            </label>

            <Link to="/professional/forgot-password">
              Forgot password?
            </Link>
          </div>

          <button
            className="primary-button auth-submit"
            type="submit"
            disabled={isLoading}
          >
            {isLoading ? "Signing In..." : "Sign In"}
          </button>
        </form>

        <div className="account-links auth-account-links">
          <span>New to Zeth Health?</span>
          <Link to="/professional/register">Create an account</Link>
        </div>

        <Link className="return-home-link" to="/">
          ← Return to homepage
        </Link>
      </div>
    </AuthLayout>
  );
}

export default ProfessionalLogin;
